module.exports = __webpack_public_path__ + "img/Ruby.97112c9.png";